import { Injectable } from '@angular/core';

import { PlatformService } from './ssr/platform.service';
import { StateService } from './state.service';

@Injectable({ providedIn: 'root' })
export class AppExplainersService {
  constructor(private stateService: StateService, private platformService: PlatformService) {}

  public shouldShowVendorChatExplainer(): boolean {
    return !this.platformService.isBrowser && !this.stateService.state?.vendorChatExplainerShown;
  }

  public markVendorChatExplainerAsAlreadyShown(): void {
    this.stateService.update({ vendorChatExplainerShown: true });
  }
}
